import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin.js'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(DrawSVGPlugin)
gsap.registerPlugin(ScrollTrigger)

/**
 * VideoModule component.
 */
export default class VideoModule {
    /**
     * Constructs a new VideoModule section.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */
    constructor(options) {
        this.element = options.element
        this.contentelement = options.element

        const videoModuleTL = gsap.timeline({ paused: true })

        videoModuleTL.to(this.element, { duration: 0.5, autoAlpha: 1, opactity: 1, visibility: 'visible', y: 0 }, '.5')

        ScrollTrigger.create({
            trigger: this.element,
            start: 'top bottom-=100px',
            markers: false,
            scroller: 'body',
            onEnter: () => {
                videoModuleTL.play()
            }
        })
    }

}



// WEBPACK FOOTER //
// ./components/section/video-module/index.js